/*
 * @Author: your name
 * @Date: 2022-02-06 15:40:03
 * @LastEditTime: 2024-01-06 14:59:41
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsyTextEditor\index.jsx
 */

import React from 'react'
import { BsyUtils } from '../../utils/Utils';
import BsyNumber from '../BsyNumber';
import BsySelect from '../BsySelect';
import { BsyWidget } from '../BsyWidget';
import './index.css'

export default class BsyNumberLimit extends BsyWidget {

  constructor(props) {
    super({
      baseCls: "bsy-number-limit",
      width4number: 150,
      tick: [], //特殊情况下使用
      ...props
    })
    this.state = {
      value: this.options.value,
    }
    this.tickValue = props.tickValue || {};
  }

  handleChange(event) {
    this.value = event.target.value;
    this.setState({ value: event.target.value });
  }

  componentWillUnMount = () => {

  }

  getText = () => {
    let a = this.max.getText()
      , b = this.min.getText()
      , c = { min: b, max: a };
    return c
  }

  getValue = () => {
    var a = this.maxNumber.getValue(),
      b = this.minNumber.getValue(),
      c = {};
    BsyUtils.isNull(b) || (c.min = b);
    BsyUtils.isNull(a) || (c.max = a);
    return c
  }

  getContextMin = (context) => {
    this.min = context
  }


  getContextMax = (context) => {
    this.max = context
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    //防止多次重复 setState
    let props = {};
    if (!BsyUtils.compare(nextProps.value, this.state.value)) {
      props.value = nextProps.value;
    }
    if (nextProps.tickValue !== this.tickValue) {
      props.tickValue = nextProps.tickValue;
      this.tickValue = nextProps.tickValue;
    }

    if (!BsyUtils.isObjectEmpty(props)) {
      this.setState({
        ...props
      }, () => {
        // if (this.props.onStopEdit) {
        //     this.props.onStopEdit(nextProps.value)
        // }
      })
    }
  }

  getTickValue = () => {
    return this.tickValue;
  }


  render() {
    let that = this;
    const { cssName, width4number, tick,height } = this.options;
    const { value } = this.state
    let css = {
      width: this.options.width,
      height: this.options.height,
    }
    return (
      <div className={cssName} style={css}
        ref={this.element}
      >
        <div className='limit-item'>
          <BsyNumber
            getContext={this.getContextMin}
            width={width4number}
            height={this.options.height}
            value={value ? value.min ? value.min : null : null}
            allowDecimals={true}
            onStopEdit={e1 => {
              BsyUtils.applyFunc(that, that.options.onStopEdit, [], !1)
            }}
          >

          </BsyNumber>
          {
            tick.length ? <BsySelect
              allowBlank={false}
              searchable={false}
              width={80}
              minWidth={80}
              height={this.options.height}
              value={this.tickValue ? this.tickValue.min : null}
              items={[...tick]}
              onStopEdit={(val) => {
                this.tickValue = this.tickValue || {};
                this.tickValue.min = val;
                BsyUtils.applyFunc(that, that.options.onStopEdit, [], !1)
              }}

            ></BsySelect> : ''
          }
        </div>
        <div className=" limit-to">~</div>
        <div className='limit-item'>
          <BsyNumber
            getContext={this.getContextMax}
            width={width4number}
            height={this.options.height}
            value={value ? value.max ? value.max : null : null}
            allowDecimals={true}
            onStopEdit={e1 => {
              BsyUtils.applyFunc(that, that.options.onStopEdit, [], !1)
            }}
          >

          </BsyNumber>
          {
            tick.length ? <BsySelect
              allowBlank={false}
              searchable={false}
              width={80}
              minWidth={80}
              height={this.options.height}
              value={this.tickValue ? this.tickValue.max : null}
              items={[...tick]}
              onStopEdit={(val) => {
                this.tickValue = this.tickValue || {};
                this.tickValue.max = val;
                BsyUtils.applyFunc(that, that.options.onStopEdit, [], !1)
              }}

            ></BsySelect> : ''
          }
        </div>
      </div>
    )
  }
}
